export default "__VITE_ASSET__16a44747__"